module.exports = __webpack_public_path__ + "img/future5.348e082b.png";